import { api, mediaSrc } from "@/lib/api";
import { Megaphone } from "lucide-react";

const TIER_LABELS = {
  premium: { label: "PREMIUM", color: "bg-[#7B1FA2] text-white" },
  sponsor: { label: "SPONSORISÉ", color: "bg-[#1A1918]/85 text-white" },
  boost: { label: "BOOSTÉ", color: "bg-[#E65100] text-white" },
  none: { label: "SPONSORISÉ", color: "bg-[#1A1918]/85 text-white" },
};

export default function InlineAd({ ad }) {
  if (!ad) return null;
  const tier = TIER_LABELS[ad.tier || "none"];
  const onClick = () => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
    if (ad.link?.startsWith("http")) window.open(ad.link, "_blank", "noopener");
    else if (ad.link) window.location.href = ad.link;
  };
  return (
    <button
      type="button"
      data-testid={`inline-ad-${ad.id}`}
      onClick={onClick}
      className="group block w-full text-left rounded-xl overflow-hidden bg-white border border-[#E8E6E1] product-card active:scale-[0.98] transition relative"
    >
      <div className="relative aspect-square bg-[#F3F1EC] overflow-hidden">
        <img src={mediaSrc(ad.image)} alt={ad.title} className="h-full w-full object-cover" loading="lazy" />
        <div className={`absolute top-2 left-2 inline-flex items-center gap-1 text-[10px] font-bold px-2 py-1 rounded-md backdrop-blur-sm ${tier.color}`}>
          <Megaphone className="h-3 w-3" />
          {tier.label}
        </div>
      </div>
      <div className="p-3">
        <div className="text-[10px] font-bold uppercase tracking-widest text-[#E65100]">Publicité</div>
        <div className="mt-1 text-sm font-bold text-[#1A1918] line-clamp-2 leading-snug">{ad.title}</div>
        {ad.subtitle && <div className="mt-1 text-[11px] text-[#73706B] line-clamp-2">{ad.subtitle}</div>}
        <div className="mt-2 text-[11px] text-[#E65100] font-semibold group-hover:underline">Voir l'offre →</div>
      </div>
    </button>
  );
}

/**
 * Inject inline ads into product list following Leboncoin-inspired rules:
 * - never first item
 * - never 2 ads in a row
 * - 1 ad every `frequency` products
 * - max 3 ads per page total
 */
export function injectInlineAds(products, ads, defaultFrequency = 6) {
  if (!ads?.length || !products?.length) return products || [];
  const freq = Math.max(3, ads[0]?.frequency || defaultFrequency);
  const MAX_ADS = 3;
  const out = [];
  let adsShown = 0;
  let adIdx = 0;
  products.forEach((p, i) => {
    out.push(p);
    // Insert ad after position (i+1) multiple of freq, but never as first element
    // (i+1) % freq === 0 ensures the ad comes AFTER the freq-th product, never first.
    if ((i + 1) % freq === 0 && adsShown < MAX_ADS && i < products.length - 1) {
      const ad = ads[adIdx % ads.length];
      out.push({ __ad: true, ad });
      adsShown++;
      adIdx++;
    }
  });
  return out;
}
